import { AdyenTransactionsOverview } from "../pages/reporting/AdyenTransactionsOverview";
import { AdyenPaiementsOverview } from "../pages/reporting/AdyenPaiementsOverview";
import { HomePage } from "../pages/HomePage";
import PaymentComponent from "../pages/webPayment/PaymentComponent";

export const routes = [
  {
    element: <HomePage />,
    path: "/",
  },
  {
    element: <AdyenPaiementsOverview />,
    path: "/paiements",
  },
  {
    element: <AdyenTransactionsOverview />,
    path: "/transactions",
  },
  {
    element: <PaymentComponent />,
    path: "/payment",
  },
  {
    element: <PaymentComponent />,
    path: "/successPayment",
  },
  {
    element: <PaymentComponent />,
    path: "/failedPayment",
  },
];
